<!-- Time Input Field -->
<input
  type="text"
  class="time-input"
  placeholder="Select time saved"
  readonly
  (click)="openTimePicker()"
  #timeInput
/><span style="margin-left: -26px;display: flex;align-items: center;justify-content: center;" class="watch-icon"><img src="/assets/icons/clock.svg" (click)="openTimePicker()" alt="clock"/></span>


<!-- Custom Dropdown -->
<div class="dropdown" *ngIf="showDropdown" [ngStyle]="dropdownStyle" #dropdown>
  <div class="header"><div>Hours</div> <div>Minutes</div></div>
  <div class="time-picker">
    <div class="time-scroll" #hourScroll>
      <div
        *ngFor="let h of hours"
        (click)="selectHour(h)"
        [ngClass]="{ selected: selectedHour === h }"
      >
        {{ h }}
      </div>
    </div>
    <div class="time-scroll" #minuteScroll>
      <div
        *ngFor="let m of minutes"
        (click)="selectMinute(m)"
        [ngClass]="{ selected: selectedMinute === m }"
      >
        {{ m }}
      </div>
    </div>
  </div>
  <div class="time-picker-buttons">
    <button class="cancel-btn" (click)="closeTimePicker()">Cancel</button>
    <button class="set-btn" (click)="setTime(timeInput)">Set</button>
  </div>
</div>
